export default __webpack_public_path__ + "static/Roobert-Regular-dabbfe10b47eac456b6641af578b5867.woff2";